<template>
  <main class="registSearchOrg">
    <div class="title">请选择您要注册的组织机构</div>
    <div class="search">
      <i class="iconfont icon-search-1 search-icon" @click="handleSearch"></i>
      <input type="text" v-model.trim="queryKey" />
      <i class="iconfont iconshan_chu clear-icon" :class="{show: queryKey.length > 0}" @click="handleClear"></i>
    </div>
    <ul v-if="list.length > 0" class="org-list">
      <li
        class="org-item"
        v-for="item in list"
        :key="item.id"
        :class="{active: item.id == orgId}"
        @click="handleChangeOrg(item)"
      >
        <div class="checkbox" :class="{active: item.id == orgId}"></div>
        <div class="org-content">
          <img v-if="item.unitAttr === '8'" class="org-logo" src="@/assets/image/icon1.png" alt="" />
          <img v-else class="org-logo" src="@/assets/image/icon2.png" alt="" />
          <span class="org-name" v-html="setKeyWord(item.displayName)"></span>
        </div>
      </li>
    </ul>
    <div v-else class="org-list current">
      <img src="@/assets/image/table-empty.png" height="120" alt="" />
    </div>
    <div class="next">
      <div class="next-btn" :class="{active: orgId}" @click="handleNext">下一步</div>
    </div>
  </main>
</template>

<script>
import {selectOrgByNameQuery, applyToOrg} from '@/api'
export default {
  name: 'registSearchOrg',
  data() {
    return {
      queryKey: '',
      list: [],
      orgId: '',
      registInfo: {
        orgInfo: '',
        verifyId: '',
        phone: '',
        openAccountId: ''
      }
    }
  },
  methods: {
    setKeyWord(str) {
      const reg = new RegExp(this.queryKey, 'g')
      return str.replace(reg, `<span style="color: #4C84FF;">${this.queryKey}</span>`)
    },
    handleSearch() {
      if (!this.queryKey) {
        return false
      }
      this.handleSearchOrg()
    },
    async handleSearchOrg() {
      try {
        const params = {queryKey: this.queryKey}
        const res = await selectOrgByNameQuery(params)
        console.log('res', res)
        if (res.code === 0 && res.success) {
          const data = res.data
          this.list = data
        }
      } catch (error) {
        window.console.log('selectOrgByNameQuery', error)
      }
    },
    handleClear() {
      this.queryKey = ''
      this.list = []
      this.orgId = ''
      this.registInfo.orgInfo = ''
    },
    handleChangeOrg(item) {
      this.orgId = item.id
      this.registInfo.orgInfo = {id: item.id, displayName: item.displayName, unitAttr: item.unitAttr}
    },
    handleNext() {
      if (!this.registInfo.orgInfo.id) {
        return this.$Toast.fail('请选择机构')
      }
      console.log('registInfo', this.registInfo)
      // 存在已注册机构
      if (this.registInfo.openAccountId) {
        const params = {
          openAccountId: this.registInfo.openAccountId,
          orgId: this.registInfo.orgInfo.id
        }
        applyToOrg(params).then(res => {
          if (res.success) {
            localStorage.clear()
            this.$router.push({
              path: '/success',
              query: {type: 3}
            })
          } else {
            this.$Toast.fail(res.msg)
          }
        })
      } else {
        localStorage.setItem('registInfo', JSON.stringify(this.registInfo))
        this.$router.push('/registSetName')
      }
    }
  },
  mounted() {
    const {phone, verifyId, openAccountId} = this.$route.query
    this.registInfo.verifyId = verifyId
    this.registInfo.phone = phone
    this.registInfo.openAccountId = openAccountId
  }
}
</script>

<style lang="scss" scoped>
.registSearchOrg {
  width: 100%;
  height: 100vh;
  padding: 12px 16px;
  box-sizing: border-box;
  font-size: 14px;
  background-color: #fff;
  .title {
    font-size: 15px;
    color: #808080;
  }
  .search {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
    width: 100%;
    height: 32px;
    padding: 0 16px;
    box-sizing: border-box;
    border-radius: 18px;
    background: #f5f5f5;
    input {
      width: 85%;
      background: transparent;
      border: none;
    }
    .search-icon {
      color: #b3b3b3;
    }
    .clear-icon {
      visibility: hidden;
      color: #b3b3b3;
      &.show {
        visibility: visible;
      }
    }
  }
  .org-list {
    margin-top: 8px;
    width: 100%;
    height: calc(100vh - 102px - 68px);
    overflow-x: auto;
    &.current {
      display: flex;
      justify-content: center;
      img {
        margin-top: 100px;
      }
    }
    li {
      display: flex;
      align-items: center;
      width: 100%;
      height: 56px;
      &.active {
        background: #e0efff;
      }
      .checkbox {
        position: relative;
        margin-right: 12px;
        flex: 0 0 18px;
        width: 18px;
        height: 18px;
        border: 1px solid #a1a1a1;
        border-radius: 50%;
        &.active {
          background: #007aff;
          border-color: #007aff;
          &::before {
            opacity: 1;
          }
          &::after {
            opacity: 1;
          }
        }
        &::before {
          content: '';
          position: absolute;
          left: 9px;
          top: 5px;
          width: 2px;
          height: 8px;
          transform: rotate(45deg);
          background: #fff;
          opacity: 0;
        }
        &::after {
          content: '';
          position: absolute;
          position: absolute;
          left: 5px;
          top: 8px;
          width: 2px;
          height: 5px;
          transform: rotate(-45deg);
          background: #fff;
          opacity: 0;
        }
      }
      .org-content {
        flex: 1;
        margin-left: 12px;
        display: flex;
        align-items: center;
        height: 100%;
        border-bottom: 1px solid #e5e5e5;
        box-sizing: border-box;
        .org-logo {
          width: 36px;
          height: 36px;
        }
        .org-name {
          margin-left: 12px;
        }
      }
    }
  }
  .next {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 68px;
    padding: 12px 16px;
    box-sizing: border-box;
    .next-btn {
      width: 100%;
      height: 100%;
      background: rgba(#007aff, 0.4);
      border-radius: 1000px;
      color: #fff;
      font-size: 16px;
      text-align: center;
      line-height: 44px;
      &.active {
        background: rgba(#007aff, 1);
      }
    }
  }
}
</style>
